import { useEffect } from "react";

interface UseBrowserOnlineStatusProps {
  onStatusChange?: (status: "online" | "offline") => void;
  onVisibilityChange?: (visibility: "hidden" | "visible") => void;
  onFocus?: () => void;
}

export function useBrowserOnlineStatus({
  onStatusChange,
  onVisibilityChange,
  onFocus,
}: UseBrowserOnlineStatusProps) {
  useEffect(() => {
    const handleOnline = () => {
      onStatusChange?.("online");
    };

    const handleOffline = () => {
      onStatusChange?.("offline");
    };

    const handleVisibilityChange = () => {
      onVisibilityChange?.(document.hidden ? "hidden" : "visible");
    };

    const handleFocus = () => {
      onFocus?.();
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [onStatusChange, onVisibilityChange, onFocus]);
}
